import "./InputGroup.scss";
import Input from "./Input";
import propTypes from "prop-types";

const InputGroup = (props) => {
  const { iconOnClick, ...inputProps } = props;

  return (
    <div className="input-group">
      <div
        className="icon-container"
        onClick={(e) => iconOnClick && iconOnClick(e)}
        onKeyDown={(e) => {
          if (iconOnClick && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            iconOnClick(e);
          }
        }}
        style={iconOnClick ? { cursor: "pointer" } : {}}
        tabIndex={iconOnClick ? 0 : -1}
        role={iconOnClick ? "button" : undefined}
      >
        <div className={`${props.icon}-icon`}></div>
      </div>
      <div className="input-group-separator"></div>
      <Input {...inputProps} />
    </div>
  );
};

export default InputGroup;

InputGroup.propTypes = {
  icon: propTypes.string.isRequired,
  iconOnClick: propTypes.func,
};
